import React from 'react';
type MechanismProps = {
  className?: string;
  tone?: 'ink' | 'light';
  size?: 'sm' | 'lg';
};
const words = ['Recognize', 'Respond', 'Practice'];
export function Mechanism({
  className = '',
  tone = 'ink',
  size = 'sm'
}: MechanismProps) {
  const color = tone === 'ink' ? 'text-ink' : 'text-cream';
  const text = size === 'sm' ? 'text-[12px] tracking-[0.22em]' : 'text-[13px] tracking-[0.26em] sm:text-[15px]';
  return <p className={`flex flex-wrap items-center gap-x-3 gap-y-1 font-semibold uppercase ${color} ${text} ${className}`} data-id="element-102" data-mp="yleo4chwqyv9">
      {words.map((word, i) => <React.Fragment key={word} data-id="element-103" data-mp="18i9m8ua9qx90" data-mpi={i}>
          {i > 0 && <span className="h-1.5 w-1.5 rounded-full bg-terra" aria-hidden="true" data-id="element-104" data-mp="18hhq9icrexi7" />}
          <span data-id="element-105" data-mp="1d99l452y7pe5">{word}</span>
        </React.Fragment>)}
    </p>;
}